import React from 'react';
import { langColor } from '../utils/github';
import './TopRepos.css';

export default function TopRepos({ repos }) {
  if (!repos.length) return null;

  return (
    <div className="toprepos card card--mb">
      <div className="card__label">Top projects</div>
      <div className="toprepos__grid">
        {repos.map((r, i) => (
          <a
            className="repo"
            key={r.id}
            href={r.html_url}
            target="_blank"
            rel="noreferrer"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <div className="repo__header">
              <svg className="repo__icon" viewBox="0 0 16 16" width="14" height="14" fill="currentColor">
                <path d="M2 2.5A2.5 2.5 0 014.5 0h8.75a.75.75 0 01.75.75v12.5a.75.75 0 01-.75.75h-2.5a.75.75 0 110-1.5h1.75v-2h-8a1 1 0 00-.714 1.7.75.75 0 01-1.072 1.05A2.495 2.495 0 012 11.5v-9zm10.5-1V9h-8c-.356 0-.694.074-1 .208V2.5a1 1 0 011-1h8zM5 12.25v3.25a.25.25 0 00.4.2l1.45-1.087a.25.25 0 01.3 0L8.6 15.7a.25.25 0 00.4-.2v-3.25a.25.25 0 00-.25-.25h-3.5a.25.25 0 00-.25.25z"/>
              </svg>
              <span className="repo__name">{r.name}</span>
              <span className="repo__arrow">↗</span>
            </div>

            {r.description && (
              <p className="repo__desc">{r.description}</p>
            )}

            <div className="repo__meta">
              {r.language && (
                <span className="repo__lang">
                  <span
                    className="repo__lang-dot"
                    style={{ background: langColor(r.language) }}
                  />
                  {r.language}
                </span>
              )}
              {r.stargazers_count > 0 && (
                <span className="repo__stat">
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
                    <path fillRule="evenodd" d="M8 .25a.75.75 0 01.673.418l1.882 3.815 4.21.612a.75.75 0 01.416 1.279l-3.046 2.97.719 4.192a.75.75 0 01-1.088.791L8 12.347l-3.766 1.98a.75.75 0 01-1.088-.79l.72-4.194L.873 6.374a.75.75 0 01.416-1.28l4.21-.611L7.327.668A.75.75 0 018 .25z"/>
                  </svg>
                  {r.stargazers_count}
                </span>
              )}
              {r.forks_count > 0 && (
                <span className="repo__stat">
                  <svg width="12" height="12" viewBox="0 0 16 16" fill="currentColor">
                    <path fillRule="evenodd" d="M5 3.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm0 2.122a2.25 2.25 0 10-1.5 0v.878A2.25 2.25 0 005.75 8.5h1.5v2.128a2.251 2.251 0 101.5 0V8.5h1.5a2.25 2.25 0 002.25-2.25v-.878a2.25 2.25 0 10-1.5 0v.878a.75.75 0 01-.75.75h-4.5A.75.75 0 015 6.25v-.878zm3.75 7.378a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm3-8.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"/>
                  </svg>
                  {r.forks_count}
                </span>
              )}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
